import styles from './LoggedInHeader.module.css'


export default function LoggedInFooter() {
    return (<footer className={styles.Footer}>
        <div className='ContentContainer'>
            <div className='ContentArea'>
                <div style={{ display: 'flex', justifyContent: 'space-between', flex: 1, position: 'relative' }} className={styles.FooterLinks}>
                    <img className={styles.LargeScreen} src={"/assets/images/roundel.svg"} height={60} width={60} style={{ alignSelf: 'center' }} />
                    <a href='https://intertek.com/disclaimer/'>Disclaimer</a>
                    <a href='https://intertek.com/legal/'>Terms</a>
                    <a href='https://intertek.com/privacy/'>Privacy</a>
                    <a href='https://www.intertek.com/cookie-policy/'>Cookies</a>
                    <a href='https://cdn.intertek.com/www-intertek-com/media/investors/2024/ar/pdf/Modern-Slavery-Act-Statement-2023.pdf'>Modern Slavery Act Statement</a>
                    <a href='mailto:fastlanesupport@intertek.com'>Support</a>
                </div>
                <div className={styles.FooterLogos}>
                    <img className={styles.MobileOnly} src={"/assets/images/roundel.svg"} height={45} width={45} style={{ alignSelf: 'center' }} />
                    <img src={"/assets/images/copyrightlogo.svg"} height={45} width={249} style={{ alignSelf: 'center' }} />
                </div>
            </div>
        </div>
    </footer>)
}